import React, { useEffect, useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { dedupedRequest } from '../../utils/axios';
import EditIcon from '../icons/EditIcon';
import Plus from '../icons/Plus';
import ClientModal from './modals/ClientModal';
import UserModal from './modals/UserModal';

interface ClientUser {
  email: string;
  role: string;
}

const ClientsPanel = () => {
  const { token } = useAuth();
  const [clients, setClients] = useState<any[]>([]);
  const [activeClient, setActiveClient] = useState<any | null>(null);
  const [showNewUser, setShowNewUser] = useState<boolean | null>(false);
  const [currentClient, setCurrentClient] = useState<any | null>(null);
  const [formData, setFormData] = useState({
    name: '',
  });

  const loadClients = async () => {
    // console.log('Doing loadClients');
    dedupedRequest({ method: 'GET', url: '/admin/clients' }, { useCache: false })
      .then(res => setClients(res.data))
      .catch(err => console.error("Failed to load clients", err));
  };
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // console.log(e);
    fetch('/api/admin/clients', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData),
    })
    .then(newClient => {
      setClients([...clients, newClient]);
      setFormData({ name: '' });
      loadClients();
    });
  }

  const addUser = (client: any) => {
    // setActiveClient(client);
    setCurrentClient(client);
    setShowNewUser(true);
  }

  useEffect(() => {
    loadClients();
  }, [token]);

  return (
    <>
      <h5>Kunden</h5>
      <Table striped bordered size="sm">
        <thead>
          <tr>
            {/* <th>ID</th> */}
            <th>Name</th>
            <th>Tätigkeitsfeld/Gewerbe</th>
            <th>Tätigkeitsbeschreibung</th>
            <th>Mitarbeiteranzahl</th>
            <th>Jahresumsatz</th>
            <th>Normen</th>
            <th>Land/Bundesland</th>
          </tr>
        </thead>
        <tbody>
          {clients.map(c => (
            <React.Fragment key={c.id}>
              <tr className='client-header'>
                {/* <td>{c.id}</td> */}
                <td><strong>{c.name}</strong></td>
                <td>{c.activity_trade}</td>
                <td>{c.activity_description}</td>
                <td>{c.employees}</td>
                <td>{c.annual_turnover}</td>
                <td>{c.standards}</td>
                <td>{c.country_province}</td>
                <td className='actions'>
                  <Button className='action-btn' size="sm" onClick={() => setActiveClient(c)}>
                    <EditIcon />
                  </Button>
                </td>
              </tr>
              <tr className='client-users'>
                <td colSpan={7}>
                  Benutzer:&nbsp;
                  <Button className='action-btn' size="sm" onClick={() => addUser(c)} title='Neuen Benutzer anlegen und zuweisen'>
                    <Plus />
                  </Button>
                    {
                      // c.users && c.users.map((u: ClientUser) => (<React.Fragment key={u.email}>{u.email}&nbsp;&lt;{u.role}&gt;&nbsp;</React.Fragment>))
                      c.users && c.users.map((u: ClientUser) => (<span className='user-span' key={u.email}>{u.email}&nbsp;&lt;{u.role}&gt;&nbsp;</span>))
                    }
                </td>
                <td className='actions'>
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </Table>

      <h5>Neuer Kunde</h5>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-2">
          <Form.Control
            placeholder="Kundenname"
            value={formData.name}
            onChange={e => setFormData({ ...formData, name: e.target.value })}
            required
          />
        </Form.Group>
        <Button type="submit">Kunde hinzufügen</Button>
      </Form>
      {activeClient && (
        <ClientModal
          show={true}
          ClientId={activeClient.id}
          c={activeClient}
          onClose={() => setActiveClient(null)}
          onSave={loadClients}
        />
      )}
      {showNewUser && (
        <UserModal
          show={true}
          user={{
            email: '',
            name: '',
            role: 'client',
            client: currentClient,
          }}
          onClose={() => {setShowNewUser(false)} }
          // onClose={() => {setShowNewUser(false); setActiveClient(null);} }
          onSave={loadClients}
        />
      )}
    </>
  );
};

export default ClientsPanel;
